<hfc-dropdown
  [items]="countries"
  [filterWith]="filterWithFn"
  icon="arrow_drop_down"
  [(ngModel)]="value"
  (ngModelChange)="onValueChange()"
  [class.hf-invalid]="hfInvalid"
>
</hfc-dropdown>
